import { z } from "zod";

import { api } from "@/redux/api";

import { BulkAssign } from "../../../schema/list-bulk-actions.schema";

const ConnectedLeadSchema = z.object({
	listPersonId: z.number(),
	name: z.string().nullable(),
	companyName: z.string().nullable(),
	connectedTo: z.array(z.string()),
});

const ConnectedLeadGroupSchema = z.object({
	count: z.number(),
	leads: z.array(ConnectedLeadSchema),
});

/** `POST list/campaign-connections` (PREC-4426): `LeadConnectionSummaryDTO` on the API. */
export const LeadConnectionSummarySchema = z.object({
	total: z.number(),
	senderConnected: ConnectedLeadGroupSchema,
	colleagueOnly: ConnectedLeadGroupSchema,
});

export type ConnectedLead = z.infer<typeof ConnectedLeadSchema>;
export type LeadConnectionSummary = z.infer<typeof LeadConnectionSummarySchema>;

/** The selection exactly as `bulkAssign` takes it, plus the campaign's LinkedIn senders. */
export type CampaignConnectionCheck = Omit<BulkAssign, "assignStatus"> & {
	senderUserIds: number[];
};

/**
 * Which of the leads about to be added to a campaign are already connected on LinkedIn (PREC-4426).
 * A query, not a mutation: nothing is written, and the answer is cached per selection.
 */
export const campaignConnectionsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		checkCampaignConnections: builder.query<LeadConnectionSummary, CampaignConnectionCheck>({
			query: (body) => ({
				url: "list/campaign-connections",
				method: "POST",
				body,
				responseSchema: LeadConnectionSummarySchema,
			}),
		}),
	}),
});

export const { useCheckCampaignConnectionsQuery } = campaignConnectionsApi;
